import React, { useMemo } from "react";

import {
    Chip,
    Button,
    Typography,
    Grid,
    Badge,
    Popover,
    Box,
    Divider,
    ClickAwayListener,
    Paper,
    Popper,
} from "@mzc-pdc/ui";
import { IconArrowDropDown } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";
import { useTranslation } from "react-i18next";

export const SearchExpand = ({ isDisabled, component, onDelete = null, onCancel, onSave, item, maxCount }) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleDelete = (event) => {
        event.stopPropagation();
        onDelete();
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    const maxWidth = useMemo(() => {
        switch (item.type) {
            case "assetDateRange":
                return undefined;
            case "categories":
                return "600px";
            default:
                return "328px";
        }
    }, [item]);

    const minWidth = useMemo(() => {
        switch (item.type) {
            case "categories":
                return "600px";
            default:
                return "328px";
        }
    }, [item]);

    return (
        <>
            {item.essential ? (
                <Chip
                    active={!!item.value}
                    label={
                        <Grid alignItems="center" container gap={1}>
                            <Typography
                                color={item.label ? "primary" : theme.palette.greySecondary.main}
                                variant="body3_400"
                            >
                                {t(`common::label::${item.title}`)}
                            </Typography>
                            <Typography>{item.label ? t(`common::label::${item.label}`, item.label) : ""}</Typography>
                            {item.length > 0 && (
                                <Box>
                                    <Badge badgeContent={<>+{item.length}</>} color="primary" />
                                </Box>
                            )}
                            <Box>
                                <IconArrowDropDown size={20} color={theme.palette.greySecondary[500]} />
                            </Box>
                        </Grid>
                    }
                    onClick={handleClick}
                    size="medium"
                    variant="filter"
                    onDelete={item.value ? handleDelete : undefined}
                />
            ) : (
                <Chip
                    active
                    label={
                        <Grid alignItems="center" container gap={1}>
                            <Typography color="primary" variant="body3_400">
                                {t(`common::label::${item.title}`, item.title)}
                            </Typography>
                            <Typography>{item.label ? t(`common::label::${item.label}`, item.label) : ""}</Typography>
                            {item.length > 0 && (
                                <Badge sx={{ ml: 2, mr: 1 }} badgeContent={<>+{item.length}</>} color="primary" />
                            )}
                            <Box>
                                <IconArrowDropDown size={20} color={theme.palette.secondary[400]} />
                            </Box>
                            <Divider flexItem orientation="vertical" />
                        </Grid>
                    }
                    onClick={handleClick}
                    onDelete={handleDelete}
                    size="medium"
                    variant="filter"
                />
            )}
            <Popper
                disablePortal={true}
                key={id}
                id={id}
                open={open}
                placement={"bottom-start"}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                sx={{ zIndex: 900 }}
            >
                <ClickAwayListener onClickAway={handleClose}>
                    <Paper sx={{ padding: "16px", marginTop: `5px` }}>
                        <Box
                            sx={{
                                minWidth,
                                maxWidth,
                            }}
                        >
                            {component}
                            <Divider flexItem />
                            <Grid
                                container
                                flexDirection={"row"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                            >
                                <Box>{maxCount}</Box>
                                <Box mt={1} sx={{ textAlign: `right` }}>
                                    <Button
                                        type={"button"}
                                        variant={"text"}
                                        size={"small"}
                                        color={"inherit"}
                                        minWidth={1}
                                        onClick={() => {
                                            onCancel && onCancel();
                                            handleClose();
                                        }}
                                    >
                                        {t("common::label::Cancel")}
                                    </Button>
                                    <Button
                                        type={"button"}
                                        variant={"contained"}
                                        size={"small"}
                                        color={"primary"}
                                        minWidth={1}
                                        disabled={isDisabled}
                                        sx={{ marginLeft: `4px` }}
                                        onClick={() => {
                                            onSave && onSave();
                                            handleClose();
                                        }}
                                    >
                                        {t("common::label::Apply")}
                                    </Button>
                                </Box>
                            </Grid>
                        </Box>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </>
    );
};

export default SearchExpand;
